import { writable } from "svelte/store";
function createSearchStore() {
    const store = writable({
        scrollPos: 0,
        term: "",
        results: [],
        total: 0,
        index: 0,
    });
    return {
        subscribe: store.subscribe,
        setSearchTerm: (term) => store.update((val) => ({ ...val, term })),
        setScrollPos: (scrollPos) => store.update((val) => ({ ...val, scrollPos })),
        reset: () => store.update((val) => ({ ...val, index: 0 })),
        nextPage: () => store.update((val) => ({ ...val, index: val.index + 1 })),
        setResults: (results) => store.update((val) => ({ ...val, results })),
        setTotal: (total) => store.update((val) => ({ ...val, total })),
        appendResults: (results) => store.update((val) => ({ ...val, results: [...val.results, ...results] })),
    };
}
export const communitySearchStore = createSearchStore();
export const botSearchStore = createSearchStore();
function createSearchState() {
    const state = $state({
        scrollPos: 0,
        term: "",
        results: [],
        total: 0,
        index: 0,
    });
    return new SearchState(state);
}
export class SearchState {
    state;
    constructor(state) {
        this.state = state;
    }
    reset() {
        this.state.index = 0;
    }
    nextPage() {
        this.state.index += 1;
    }
    appendResults(results) {
        this.state.results = [...this.state.results, ...results];
    }
    get term() {
        return this.state.term;
    }
    set term(val) {
        this.state.term = val;
    }
    get scrollPos() {
        return this.state.scrollPos;
    }
    set scrollPos(val) {
        this.state.scrollPos = val;
    }
    get results() {
        return this.state.results;
    }
    set results(val) {
        this.state.results = val;
    }
    get total() {
        return this.state.total;
    }
    set total(val) {
        this.state.total = val;
    }
    get index() {
        return this.state.index;
    }
    set index(val) {
        this.state.index = val;
    }
}
export const communitySearchState = createSearchState();
export const groupSearchState = createSearchState();
export const botSearchState = createSearchState();
